import { Option } from "@/@Interfaces/Option";

export const options: Option[] = [
    { value: 100, label: 100 },
    { value: 75, label:  75 },
    { value: 50, label: 50 },
    { value: 25, label: 25 },
  ];